import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/Home";
import Accounts from "./Pages/Accounts.js";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import AccountDetails from "./Pages/AccountDetails";
import ChequeTracker from "./Pages/ChequeTracker";
import ChequeDetails from "./Components/ChequeDetails";
import MMG from "./Pages/MMGTransactions.js";
import LoanComponent from "./Pages/Loan";
import LoanDetails from "./Pages/LoanDetails";
import JournalsPage from "./Pages/JournalsPage";
import CashJournal from "./Components/CashJournal";
import PurchaseJournal from "./Components/PurchaseJournal"; 
import SalesJournal from "./Components/SalesJournal";
import GeneralJournal from "./Components/GeneralJournal";
import GeneralLedger from "./Components/GeneralLedger";
import TrialBalance from "./Components/TrialBalance";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Components/Login"; // ✅ Add Login component
import GuyanaLottery from "./Pages/GuyanaLottery";
import PhoneCards from "./Pages/PhoneCards";
import Appendix from "./Pages/Appendix";
import SimCards from "./Pages/SimCards";
import SimCardDetails
from "./Pages/SimCardDetails";

import BankReconciliation from "./Pages/BankReconciliation";

const SessionManager = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(
    sessionStorage.getItem("authenticated") === "true" ||
    localStorage.getItem("authenticated") === "true"
  );

  let timeout;

  const logout = () => {
    sessionStorage.removeItem("authenticated");
    localStorage.removeItem("authenticated");
    setAuthenticated(false);
  };

  const resetTimer = () => {
    clearTimeout(timeout);
    timeout = setTimeout(logout, 5 * 60 * 1000); // 5 minutes
  };

  useEffect(() => {
    if (authenticated) {
      window.addEventListener("mousemove", resetTimer);
      window.addEventListener("keydown", resetTimer);
      resetTimer();
    }

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
    };
  }, [authenticated]);

  return authenticated ? children : <Login onLogin={() => setAuthenticated(true)} />;
};

const AppWrapper = () => {
  const location = useLocation();
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/accounts/:id" element={<AccountDetails />} />
        <Route path="/cheque-tracker" element={<ChequeTracker />} />
        <Route path="/cheque-details/:cheque_number" element={<ChequeDetails />} />
        <Route path="/mmg" element={<MMG />} />
        <Route path="/loan" element={<LoanComponent />} />
        <Route path="/loan/:loanId" element={<LoanDetails loans={LoanComponent.loans} transactions={LoanComponent.transactions} />} />
        <Route path="/journals" element={<JournalsPage />} />
        <Route path="/journals/cash" element={<CashJournal />} />
        <Route path="/journals/purchases" element={<PurchaseJournal />} />
        <Route path="/journals/sales" element={<SalesJournal />} />
        <Route path="/journals/general" element={<GeneralJournal />} />
        <Route path="/ledger" element={<GeneralLedger />} />
        <Route path="/trial-balance" element={<TrialBalance />} />
        <Route path="/lottery" element={<GuyanaLottery />} />
        <Route path="/phone-cards" element={<PhoneCards />} />
        <Route path="/appendix"element={<Appendix />} />
        <Route path="/sim-cards"element={<SimCards />}/>
        <Route
    path="/bank-reconciliation"
    element={<BankReconciliation />}
/>

        <Route
  path="/sim-cards/:id"
  element={<SimCardDetails />}
/>



      </Routes>
      <Footer show={location.pathname === "/"} />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </>
  );
};

const App = () => {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <Router>
        <SessionManager>
          <AppWrapper />
        </SessionManager>
      </Router>
    </>
  );
};

export default App;
